import AboutSection from './AboutSection';
import AboutSectionContainer from './AboutSection.container';

export default AboutSectionContainer(AboutSection);
